import {
  camelCase,
  underscoreCase
} from './stringTransform'

function isObjectOrArray(target) {
  return typeof target === 'object' && (Object.prototype.toString.call(target) === '[object Object]' || Array.isArray(target))
}

function handleProp(prop, keyReplace, transformConfig, next) {
  if (isObjectOrArray(prop)) {
    return next(prop, keyReplace, transformConfig)
  }

  return prop
}

function handleKey(key, keyReplace, transformConfig) {
  return keyReplace(key, transformConfig)
}

function handleSource(source, keyReplace, transformConfig) {
  const sourceIsArray = Array.isArray(source)
  const dist = sourceIsArray ? [] : {}

  for (const key in source) {
    if (source.hasOwnProperty(key)) {
      const parsedKey = sourceIsArray ? key : handleKey(key, keyReplace, transformConfig)
      const parsedProp = handleProp(source[key], keyReplace, transformConfig, handleSource)

      dist[parsedKey] = parsedProp
    }
  }

  return dist
}

/* -------------------------------- */

function toSomeStyle(source, transformOpts, caseReplacer) {
  if (!isObjectOrArray(source)) {
    return source
  }

  const transformConfig = typeof transformOpts === 'object' ? transformOpts : undefined
  const transformFinalFn = typeof transformOpts === 'function' ? transformOpts : undefined

  const result = handleSource(source, caseReplacer, transformConfig)

  return transformFinalFn ? transformFinalFn(result) : result
}

function toJsStyle(source, transformOpts) {
  return toSomeStyle(source, transformOpts, camelCase)
}

function toPythonStyle(source, transformOpts) {
  return toSomeStyle(source, transformOpts, underscoreCase)
}

function wrapHttp() {
  throw new Error('[data-transform] wrapHtpp is deprecated, use http.get({ transform: true }) instead')
}

export default {
  wrapHttp,

  toJsStyle,
  toPythonStyle,
  camelCase,
  underscoreCase
}

export {
  wrapHttp,

  // parse object
  toJsStyle,
  toPythonStyle,

  // parse string
  camelCase,
  underscoreCase
}
